<template>
  <div>
    <a :class="[{hide: showTable}, 'button alt show-tariff-table hide-for-medium-up']" @click="showTable = !showTable">
      {{ $t('product-detail.tariffs-show') }}
    </a>

    <div id="customer-group-price-table-header" :class="[{hide: !showTable}, 'table-header']">
      {{ $t('product-detail.tariffs-header', { date: this.$d(headerDate, 'date-long') }) }}
    </div>

    <table :class="[{hide: !showTable}, 'responsive-table']" role="grid">
      <thead>
        <tr>
          <th scope="col">{{ $t('generic.age') }}</th>
          <th v-for="term in termsToShow" :key="term.id" scope="col">{{ term.title }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="customerGroup in customerGroupsToShow" :key="customerGroup.id"
            :ref="customerGroup.id"
            :class="[{ selected: selectedCustomerGroup && customerGroup.id === selectedCustomerGroup.id }]"
            data-selectable
            tabindex="0"
            @click="selectCustomerGroup(customerGroup)"
            @keydown="pickCustomerGroupByKeys"
        >
          <td :data-title="$t('generic.age')">{{ customerGroup.title }}</td>
          <td v-for="term in termsToShow"
              :key="`${customerGroup.id}-${term.id}`"
              :data-title="term.title">
            {{ priceForTermAndCustomerGroup(term, customerGroup) }}
          </td>
        </tr>
      </tbody>
    </table>

    <a :class="[{hide: !showTable}, 'button alt hide-tariff-table']" @click="showTable = false">
      {{ $t('product-detail.tariffs-hide') }}
    </a>
  </div>
</template>

<script>
import { CustomerGroup } from '../../types/filter-entity/customer-group'
import { DateString } from '../../types/date-string'
import { parseStoreDate } from '../../utils/date'

export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    configurations: {
      type: Array,
      required: true
    },
    customerGroupsToShow: {
      type: Array,
      required: true
    },
    terms: {
      type: Array,
      required: true
    },
    selectedCustomerGroup: {
      type: CustomerGroup,
      required: true
    },
    dateEffective: {
      type: DateString,
      default: null
    }
  },
  data () {
    return {
      showTable: false
    }
  },
  computed: {
    termsToShow: function () {
      return this.terms.filter(term => term.nrOfProductConfigurations > 0).sort((
        a, b) => b.termsPerYear - a.termsPerYear)
    },
    headerDate: function () {
      return this.dateEffective ? parseStoreDate(this.dateEffective) : new Date()
    }
  },
  updated: function () {
    this.clickCustomerGroup(this.getCurrentCustomerGroupIndex())
  },
  methods: {
    priceForTermAndCustomerGroup: function (term, customerGroup) {
      const configuration = this.configurations.find(
        configuration => configuration.term.id === term.id && configuration.customerGroup.id === customerGroup.id
      )

      return configuration ? this.$n(configuration.price.amount, 'currency') : '-'
    },
    selectCustomerGroup: function (customerGroup) {
      this.$emit('selectCustomerGroup', customerGroup)
    },
    pickCustomerGroupByKeys (event) {
      const currentIndex = this.getCurrentCustomerGroupIndex()
      if (event.keyCode === 38 && currentIndex > 0) {
        event.preventDefault()
        this.clickCustomerGroup(currentIndex - 1)
      } else if (event.keyCode === 40 && currentIndex < (this.customerGroupsToShow.length - 1)) {
        event.preventDefault()
        this.clickCustomerGroup(currentIndex + 1)
      }
    },
    getCurrentCustomerGroupIndex: function () {
      for (let i = 0; i < this.customerGroupsToShow.length; i++) {
        let customerGroup = this.customerGroupsToShow[i]
        if (customerGroup.id === this.selectedCustomerGroup.id) {
          return i
        }
      }
      return -1
    },
    clickCustomerGroup: function (index) {
      if (this.customerGroupsToShow[index]) {
        const element = this.$refs[this.customerGroupsToShow[index].id][0]
        element.click()
        element.focus()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/product-detail/Tariffs.vue